import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon } from '@livable/saas-react-components';
import { Button, Divider, Menu } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { EnrollmentModal } from 'src/components/resident/EnrollmentModal';
import { track, events } from 'src/configs/amplitude';
import { useStore } from 'src/stores';
import useStyles from './styles';
export const ActiveBuildingMenu = observer(props => {
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const handleShowEnrollModal = props.handleShowEnrollModal,
    handleShowManageAccessModal = props.handleShowManageAccessModal,
    id = props.id,
    menuTriggerExternal = props.menuTriggerExternal,
    setShowEnrollModalSelectedPropertyId = props.setShowEnrollModalSelectedPropertyId,
    openPropertyDetails = props.openPropertyDetails,
    customProcessUtilityBills = props.customProcessUtilityBills;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const enrollResidentTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => track(events.modalOpened('Enroll Resident')),
    'custom-attribute': '80-active-building-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "move-in"
  }), t('general.enroll_resident'));
  const MenuTriggerInternal = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, t('general.to_do')), /*#__PURE__*/React.createElement(Icon, {
      type: "triangle-down"
    }));
  };
  return /*#__PURE__*/React.createElement("span", {
    onClick: e => e.stopPropagation(),
    onKeyDown: e => e.stopPropagation(),
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    className: classes.todoDropdown,
    id: "action-menu-trigger",
    "aria-controls": "action-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "resident menu",
    onClick: handleClick,
    state: open ? 'active' : undefined,
    'custom-attribute': '81-active-building-menu'
  }, menuTriggerExternal !== undefined ? menuTriggerExternal : /*#__PURE__*/React.createElement(MenuTriggerInternal, null)), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    'custom-attribute': '82-active-building-menu'
  }, !store.company.companyFeatureStore.disableEnrollResident && /*#__PURE__*/React.createElement(React.Fragment, null, handleShowEnrollModal !== undefined ? /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: event => {
      track(events.modalOpened('Enroll Resident'));
      if (handleShowEnrollModal !== undefined) {
        event.stopPropagation();
        handleClose();
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        setShowEnrollModalSelectedPropertyId && setShowEnrollModalSelectedPropertyId(id);
        handleShowEnrollModal(true);
      }
    },
    'custom-attribute': '83-active-building-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "move-in"
  }), t('general.enroll_resident')) : /*#__PURE__*/React.createElement(EnrollmentModal, {
    propertyId: id,
    trigger: enrollResidentTrigger
  }), /*#__PURE__*/React.createElement(Divider, null)), store.account.featureFlagsStore.getIsMultiAccountAccessEnabled && menuTriggerExternal !== undefined && /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: event => {
      event.stopPropagation();
      handleShowManageAccessModal();
    },
    'custom-attribute': '84-active-building-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "user-add"
  }), t('general.share')), customProcessUtilityBills !== undefined ? /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: event => {
      event.stopPropagation();
      customProcessUtilityBills(id);
    },
    'custom-attribute': '85-active-building-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "table"
  }), t('general.process_utility_bills')) : /*#__PURE__*/React.createElement(Button, {
    component: RouterLink,
    to: "/allocation_tables?allocationCycleId=".concat(store.allocations.currentCycle.id, "&propertyId=").concat(id),
    variant: "menuAction",
    'custom-attribute': '85-active-building-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "table"
  }), t('general.process_utility_bills')), /*#__PURE__*/React.createElement(Divider, null), openPropertyDetails ? /*#__PURE__*/React.createElement(Button, {
    id: "editNewProperty",
    variant: "menuAction",
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      openPropertyDetails(id);
    },
    'custom-attribute': '86-active-building-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), t('general.edit_property')) : /*#__PURE__*/React.createElement(Button, {
    id: "editNewProperty",
    variant: "menuAction",
    component: RouterLink,
    to: "/edit_property?id=".concat(id),
    'custom-attribute': '87-active-building-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), t('general.edit_property'))));
});